module.exports = __webpack_public_path__ + "img/source_book-con01.cbc73d0c.png";